export default {
  header: {
    title: 'Osta lahjakortti',
  },
  items: {
    gift_card: {
      label: 'Lahjakortti',
      title: 'Valitse haluamasi summa',
      description: 'Lisää lahjakortti halutulla määrällä ostoskoriin',
    },
    expiration: {
      label: 'Voimassa 3 vuotta',
      title: 'Nauti lahjoittamisesta!',
      description: 'Vastaanottaja voi lunastaa lahjakortin joustavasti 3 vuoden kuluessa.',
    },
    delivery: {
      label: 'Toimitus heti sähköpostitse PDF-muodossa',
      title: 'Välitön toimitus sähköpostitse PDF-muodossa',
      description: 'Turvallisen maksun jälkeen luottokortilla, PayPalilla tai giropaylla saat lahjakortin heti.',
    },
  },
  form: {
    value: {
      title: 'Valitse lahjakortin summa',
      custom: {
        label: 'Mukautettu',
        placeholder: 'Syötä summa',
      },
    },
    quantity: {
      title: 'Määrä',
    },
    email: {
      title: 'Mikä on sähköpostiosoitteesi, johon voimme lähettää lahjakortin?',
      placeholder: 'Sähköpostiosoitteesi',
    },
  },
  confirmation: {
    title: {
      title: 'Luodaanko lahjakortti?',
      subtitle_one: 'Haluaisitko luoda 1 lahjakortin summalle {{value}}?',
      subtitle_other: 'Haluaisitko luoda {{count}} lahjakorttia summalle {{value}}?',
    },
    description: {
      total: 'Yhteensä:',
      email: 'Sähköposti:',
      quantity: 'Määrä',
      amount: 'Summa',
    },
    footer: {
      cancel: 'Peruuta',
      confirm: 'Vahvista',
    },
  },
  buttons: {
    create: 'Luo',
  },
  toasts: {
    error: 'Lahjakortin luominen epäonnistui.',
    success: 'Lahjakortti luotu onnistuneesti.',
  },
};
